import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from '@theme/colors';
import { Button } from '@atoms';

const Label = styled.label`
  display: block;
  width: 100%;
  cursor: pointer;
  color: ${colors.WHITE};
`;

const HiddenInput = styled.input`
  display: none;
`;

export default class FileUpload extends PureComponent {
  render() {
    const { id, multiple, setFilesToUpload, audio, caption, small, big } = this.props;
    return (
      <div>
        <Button primary big={big} small={small} style={{ padding: 0 }}>
          <Label htmlFor={id}>{caption}</Label>
        </Button>
        <HiddenInput
          id={id}
          type="file"
          multiple={multiple}
          onChange={({ target: { files } }) => setFilesToUpload(files)}
          accept={audio ? '.mp3' : '*'}
        />
      </div>
    );
  }
}

FileUpload.propTypes = {
  id: PropTypes.string.isRequired,
  setFilesToUpload: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  audio: PropTypes.bool,
  caption: PropTypes.node,
  big: PropTypes.bool,
  small: PropTypes.bool,
};

FileUpload.defaultProps = {
  multiple: false,
  audio: false,
  caption: 'Upload a file',
  big: true,
  small: false,
};



// WEBPACK FOOTER //
// ./components/atoms/FileUpload.js